
import { useState, useNavigate, toast, FaEyeSlash, useEffect } from '../../../common/common';
import axiosJWT from '../../../secureAPI/axiosJWT.js';
import { checkAuthToken } from '../../../secureAPI/CheckauthToken.js';
import { StopLoading, StartLoading } from '../../../Utils/loadingUtils.js';
import { showToast } from '../../../Utils/toastUtils.js';

const MidReorderProductAttributes = () => {
    const navigate = useNavigate();
   
    const [getattributes, setAttributes] = useState([]);
    const [isloggedin, setisLoading] = useState(false);
    const [isDisabled, setisDisabled] = useState(false);
    const [isattributesShow, setIsattributesShow] = useState(false);
    useEffect(() => {
        try {
            StartLoading(setisLoading, setisDisabled);
            setTimeout(async () => {
                try {
                    await getProductAttributes();  // Assuming this is defined elsewhere
                } catch (error) {
                    console.error('Failed to fetch product attributes', error);
                }
            }, 1000);
        } catch (error) {
            console.error('Error checking authentication status', error);
        }
    }, [navigate]);

    const getProductAttributes = async () => {
        try {
            StartLoading(setisLoading, setisDisabled);
            await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/GetUserProductAttributes`,{}, { withCredentials: true, credentials: 'include' })
                .then(handleProductAttributesResponse)
                .catch(handleProductAttributesError);
        } catch (err) {
            console.error('Error fetching product attributes:', err);
        }
    };
    const handleProductAttributesResponse = (res) => {
        const result = res.data;
        // console.log({ result: result });
        if (result.success === 1) {
            handleSuccessfulProductAttributes(result);
        } else {
            showToast(result.message, 'error');
        }

        StopLoading(setisLoading, setisDisabled);
    };
    const handleSuccessfulProductAttributes = (result) => {
        const { message, data } = result;
        setAttributes(data);
        showToast(message, 'success');

    };
    const handleProductAttributesError = (err) => {
        console.error(err);
        showToast('Something went wrong! Please try again later', 'error');
        StopLoading(setisLoading, setisDisabled);
    };

   

    const handleShowProductAttributes = () => {
        setIsattributesShow(true);
    }

    const handleDragEnd = (result) => {
        if (!result.destination) return;
        let tempUser = [...getattributes];
        let [selectedRow] = tempUser.splice(result.source.index, 1);
        tempUser.splice(result.destination.index, 0, selectedRow);
        setAttributes(tempUser);
        console.clear();
        //console.log(tempUser);
      };

    return { handleDragEnd, getattributes, handleShowProductAttributes, isattributesShow,handleDragEnd }
}

export default MidReorderProductAttributes